import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="approval--switch-elements"
export default class extends Controller {
  static targets = ["website", "other", "destination"];
  static values = {
    show: String,
  };

  connect() {
    this.handle({ params: { show: this.showValue } });
  }

  handle({ params }) {
    if (params.show === "website") {
      this.destinationTarget.innerHTML = this.websiteTarget.innerHTML;
    } else {
      this.destinationTarget.innerHTML = this.otherTarget.innerHTML;
    }
  }
}
